import React, { useEffect, useState } from 'react';
import { ListEncuestas } from './ListEncuestas';
import { DetalleEncuesta } from './DetalleEncuesta';
import { ResultadosEncuesta } from './ResultadosEncuesta';
import { useEncuestas } from '../../hooks/useEncuestas';
import { IListEncuesta } from '../../models/encuestas';
import { Loader } from '../../components/Loader';

type Vista = 'list' | 'detalle' | 'resultados';

export const Encuestas = () => {
  const [listadoEncuestas, setListadoEncuestas] = useState<IListEncuesta[]>([]);
  const [idEncuesta, setIdEncuesta] = useState<number>(-1);
  const [nombreEncuesta, setNombreEncuesta] = useState('');
  const [vista, setVista] = useState<Vista>('list');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { getListEncuestas } = useEncuestas();

  useEffect(() => {
    cargarEncuestas();
  }, []);

  const handleSelectEncuesta = (id: number) => {
    setIdEncuesta(id);
    setVista('detalle');
  };

  const handleVerResultados = (id: number, nombre: string) => {
    setIdEncuesta(id);
    setNombreEncuesta(nombre);
    setVista('resultados');
  };

  const cargarEncuestas = () => {
    setIsLoading(true);
    getListEncuestas()
      .then(data => {
        setIsLoading(false);
        setListadoEncuestas(data);
      })
      .catch(err => console.error(err));
  };

  const handleVolver = () => {
    setIdEncuesta(-1);
    setNombreEncuesta('');
    setVista('list');
    cargarEncuestas();
  };

  if (isLoading)
    return <Loader loadingText='Cargando Encuestas...' />;

  return (
    <div>
      {vista === 'list' && (
        <ListEncuestas
          listadoEncuestas={listadoEncuestas}
          selectEncuestaAction={handleSelectEncuesta}
          verResultadosAction={handleVerResultados}
        />
      )}
      {vista === 'detalle' && (
        <DetalleEncuesta onBack={handleVolver} idEncuesta={idEncuesta} />
      )}
      {vista === 'resultados' && (
        <ResultadosEncuesta onBack={handleVolver} idEncuesta={idEncuesta} nombreEncuesta={nombreEncuesta} />
      )}
    </div>
  );
}